import { useCurrentBrand } from 'src/context/ConfigContext/useConfig'
import { SupportedBrands } from 'src/enums'

/**
 * Whether the G2 review flow may be shown at all.
 *
 * G2 is Extend's own review listing, so the flow is Extend-brand only — a
 * white-label bank app must never surface a G2.com form. This is the single
 * source of truth for that gate, deliberately shared by BOTH render sites:
 * the `G2ReviewBox` trigger on the profile page and the `G2ReviewOverlay` that
 * renders the modal off the URL. They used to be gated independently (the box
 * checked the brand, the modal inherited the check by being its child), and
 * making the modal URL-driven silently dropped the gate from the modal. Keep
 * both sites calling this rather than re-inlining the brand comparison.
 */
export const useG2ReviewEnabled = (): boolean => {
  const { BRAND_NAME } = useCurrentBrand()

  return BRAND_NAME === SupportedBrands.Extend
}
